import _ from 'lodash';
import { churchTime } from '@/utils/date';

function formatMonth(date) {
  return churchTime(date).format('MMM');
}

function getMonthId(date) {
  return churchTime(date).month() + 1; // Jan = 1, Feb = 2 ... , Dec = 12
}

function formatDate(date) {
  return churchTime(date).format('DD MMM YYYY');
}

const transformTitheData = titheData => {
  console.log('start');
  // Attach Month to Each Tithe Data
  const titheDataWithFulfilledFlag = titheData.map(data => ({
    ...data,
    month: formatMonth(data.ns_fulfillment_date),
    monthId: getMonthId(data.ns_fulfillment_date),
    isFulfilled: data.amount > 0,
    transaction_date: formatDate(data.giving_date),
  }));

  // Group Each Data by Month
  const groupedByTitheMonth = _.groupBy(titheDataWithFulfilledFlag, d => d.month);

  console.log(groupedByTitheMonth);

  for (const month in groupedByTitheMonth) {
  }

  // Sort After Group (For giving_date i.e. transaction date)
  for (const month in groupedByTitheMonth) {
    const sorted = _.sortBy(groupedByTitheMonth[month], d => new Date(d.giving_date));
    groupedByTitheMonth[month] = sorted;
  }

  console.log('sorted tithe');
  console.log(groupedByTitheMonth);
  return groupedByTitheMonth;
};

export default transformTitheData;
